"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVerificationSessionResponseDataStatusEnum = void 0;
exports.instanceOfGetVerificationSessionResponseData = instanceOfGetVerificationSessionResponseData;
exports.GetVerificationSessionResponseDataFromJSON = GetVerificationSessionResponseDataFromJSON;
exports.GetVerificationSessionResponseDataFromJSONTyped = GetVerificationSessionResponseDataFromJSONTyped;
exports.GetVerificationSessionResponseDataToJSON = GetVerificationSessionResponseDataToJSON;
exports.GetVerificationSessionResponseDataToJSONTyped = GetVerificationSessionResponseDataToJSONTyped;
/**
 * @export
 */
exports.GetVerificationSessionResponseDataStatusEnum = {
    Processing: 'processing',
    Verified: 'verified',
    RequiresInput: 'requires_input',
    Canceled: 'canceled',
    Expired: 'expired'
};
/**
 * Check if a given object implements the GetVerificationSessionResponseData interface.
 */
function instanceOfGetVerificationSessionResponseData(value) {
    if (!('sessionId' in value) || value['sessionId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function GetVerificationSessionResponseDataFromJSON(json) {
    return GetVerificationSessionResponseDataFromJSONTyped(json, false);
}
function GetVerificationSessionResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sessionId': json['sessionId'],
        'status': json['status'],
        'reportId': json['reportId'] == null ? undefined : json['reportId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}
function GetVerificationSessionResponseDataToJSON(json) {
    return GetVerificationSessionResponseDataToJSONTyped(json, false);
}
function GetVerificationSessionResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sessionId': value['sessionId'],
        'status': value['status'],
        'reportId': value['reportId'],
        'clientSecret': value['clientSecret'],
        'url': value['url'],
    };
}
